import moment from "moment";
import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // icons

const Invoices = ({ InvoiceList }) => {
    let rentList = InvoiceList?.filter(issue => issue.Category === "Rent");
    let otherList = InvoiceList?.filter(issue => issue.Category === "Other");

    // Calculate total of Exp2
    const [showRent, setShowRent] = useState(true);
    const [showOther, setShowOther] = useState(true);
    //  rent calculated
    const rentAmount = rentList.reduce((sum, item) => sum + parseFloat(item.InstallmentAmount || 0), 0).toFixed(3);
    const rentVat = rentList.reduce((sum, item) => sum + parseFloat(item.VAT || 0), 0).toFixed(3);
    const renttotal = rentList.reduce((sum, item) => sum + parseFloat(item.Total || 0), 0).toFixed(3);
    const totalAmountpaid = rentList.reduce((sum, item) => sum + parseFloat(item.AmountPaid || 0), 0).toFixed(3);
    const rentBalance = rentList.reduce((sum, item) => sum + parseFloat(item.Balance || 0), 0).toFixed(3);

    //  Other calculated
    const OtherAmount = otherList.reduce((sum, item) => sum + parseFloat(item.InstallmentAmount || 0), 0).toFixed(3);
    const OtherVat = otherList.reduce((sum, item) => sum + parseFloat(item.VAT || 0), 0).toFixed(3);
    const otherTotal = otherList.reduce((sum, item) => sum + parseFloat(item.Total || 0), 0).toFixed(3);
    const otherAmountPaid = otherList.reduce((sum, item) => sum + parseFloat(item.AmountPaid || 0), 0).toFixed(3);
    const otherBalance = otherList.reduce((sum, item) => sum + parseFloat(item.Balance || 0), 0).toFixed(3);
    //   Total calculated
    //  Other calculated
    const Amount = InvoiceList.reduce((sum, item) => sum + parseFloat(item.InstallmentAmount || 0), 0).toFixed(3);
    const Vat = InvoiceList.reduce((sum, item) => sum + parseFloat(item.VAT || 0), 0).toFixed(3);
    const Total = InvoiceList.reduce((sum, item) => sum + parseFloat(item.Total || 0), 0).toFixed(3);
    const AmountPaid = InvoiceList.reduce((sum, item) => sum + parseFloat(item.AmountPaid || 0), 0).toFixed(3);
    const Balance = InvoiceList.reduce((sum, item) => sum + parseFloat(item.Balance || 0), 0).toFixed(3);

    return (
        <div className='gridshad mt-2 mb-3'>
            <div className="table-container" style={{ overflowX: "auto", height: "auto" }}>
                <table>
                    <thead className="dynoTable">
                        <tr>
                            <th>Description</th>
                            <th>Invoice No</th>
                            <th>Due Date</th>
                            <th>Amount</th>
                            <th>Tax</th>
                            <th>Vat</th>
                            <th>Total</th>
                            <th>Amount Paid</th>
                            <th>Balance</th>
                        </tr>
                    </thead>

                    {/* Rent Section */}
                    <tbody>
                        <tr>
                            <td colSpan={9} className="font-bold bg-light p-2 cursor-pointer"
                                style={{ cursor: "pointer", background: "#f5f5f5" }}
                                onClick={() => setShowRent(!showRent)}>
                                <div style={{ display: "flex", alignItems: "center" }} className="gap-3">
                                    <span>Rent</span>
                                    {showRent ? <FaChevronUp /> : <FaChevronDown />}
                                </div>
                            </td>
                        </tr>
                        {showRent && (
                            <>
                                {Array.isArray(rentList) &&
                                    rentList.map((data, index) => (
                                        <tr key={index}>
                                            <td><input className="p-1" value={data?.Description} disabled style={{ width: "300px" }} /></td>
                                            <td><input className="p-1" value={data?.InvoiceNo} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={moment(data?.DueDate).format("DD-MMM-YYYY")} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.InstallmentAmount} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.Tax} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.VAT} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.Total} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.AmountPaid} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.Balance} disabled style={{ width: "100%" }} /></td>
                                        </tr>
                                    ))}
                                <tr>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled value={rentAmount || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled value={rentVat || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled value={renttotal || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled value={totalAmountpaid || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled value={rentBalance || "0.000"} /></td>
                                </tr>
                            </>
                        )}
                    </tbody>

                    {/* Other Section */}
                    <tbody>
                        <tr>
                            <td colSpan={9} className="font-bold bg-light p-2 cursor-pointer"
                                style={{ cursor: "pointer", background: "#f5f5f5" }}
                                onClick={() => setShowOther(!showOther)}>
                                <div style={{ display: "flex", alignItems: "center" }} className="gap-3">
                                    <span>Other</span>
                                    {showOther ? <FaChevronUp /> : <FaChevronDown />}
                                </div>
                            </td>
                        </tr>
                        {showOther && (
                            <>
                                {Array.isArray(otherList) &&
                                    otherList.map((data, index) => (
                                        <tr key={index}>
                                            <td><input className="p-1" value={data?.Description} disabled style={{ width: "300px" }} /></td>
                                            <td><input className="p-1" value={data?.InvoiceNo} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={moment(data?.DueDate).format("DD-MMM-YYYY")} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.InstallmentAmount} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.Tax} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.VAT} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.Total} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.AmountPaid} disabled style={{ width: "100%" }} /></td>
                                            <td><input className="p-1" value={data?.Balance} disabled style={{ width: "100%" }} /></td>
                                        </tr>
                                    ))}
                                <tr>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled value={OtherAmount || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled /></td>
                                    <td><input className="p-1 w-100" disabled value={OtherVat || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled value={otherTotal || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled value={otherAmountPaid || "0.000"} /></td>
                                    <td><input className="p-1 w-100" disabled value={otherBalance || "0.000"} /></td>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td><input className="p-1 w-100" disabled /></td>
                            <td><input className="p-1 w-100" disabled /></td>
                            <td><input className="p-1 w-100" disabled /></td>
                            <td><input className="p-1 w-100" disabled value={Amount || "0.000"} /></td>
                            <td><input className="p-1 w-100" disabled /></td>
                            <td><input className="p-1 w-100" disabled value={Vat || "0.000"} /></td>
                            <td><input className="p-1 w-100" disabled value={Total || "0.000"} /></td>
                            <td><input className="p-1 w-100" disabled value={AmountPaid || "0.000"} /></td>
                            <td><input className="p-1 w-100" disabled value={Balance || "0.000"} /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Invoices;